import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2025Status: 'idle',
    startProcess2025Error: undefined as any,
    loadUserParamsProcess2025Status: 'idle',
    loadUserParamsProcess2025Error: undefined as any,
    ixHausIni_TranslatCashFlowPfadStatus: 'idle',
    ixHausIni_TranslatCashFlowPfadError: undefined as any,

    process2025List: [] as any[],
    defaultValues: undefined as any,
    ixHausIni_TranslatCashFlowPfad: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2025 = createAsyncThunk('process2025Slice/startProcess2025', async ({ process2025 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2025/`,
        prepareData(process2025),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2025Status } = getState().process2025Slice
        return startProcess2025Status !== 'pending'
    }
})

export const loadUserParamsProcess2025 = createAsyncThunk('process2025Slice/loadUserParamsProcess2025', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2025/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2025Status } = getState().process2025Slice
        return loadUserParamsProcess2025Status !== 'pending'
    }
})

export const ixHausIni_TranslatCashFlowPfad = createAsyncThunk('process2025Slice/ixHausIni_TranslatCashFlowPfad', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/IxHausIni_TranslatCashFlowPfad/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { ixHausIni_TranslatCashFlowPfadStatus } = getState().process2025Slice
        return ixHausIni_TranslatCashFlowPfadStatus !== 'pending'
    }
})

const Process2025Slice = createSlice({
    name: 'process2025Slice',
    initialState,
    reducers: {
        resetstartProcess2025: (state) => {
            state.job = undefined
            state.startProcess2025Error = undefined
        },
        resetstartProcess2025Error: (state) => {
            state.startProcess2025Error = undefined
        },
        resetloadUserParamsProcess2025: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2025Error = undefined
        },
        resetloadUserParamsProcess2025Error: (state) => {
            state.loadUserParamsProcess2025Error = undefined
        },
        resetixHausIni_TranslatCashFlowPfad: (state) => {
            state.ixHausIni_TranslatCashFlowPfad = undefined
            state.ixHausIni_TranslatCashFlowPfadError = undefined
        },
        resetixHausIni_TranslatCashFlowPfadError: (state) => {
            state.ixHausIni_TranslatCashFlowPfadError = undefined
        },
        removeFromProcess2025ListById: (state, action) => {
            state.process2025List = state.process2025List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2025ListByIds: (state, action) => {
            state.process2025List = state.process2025List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2025List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2025Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2025List = []
            state.startProcess2025Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2025.pending, (state) => {
            state.startProcess2025Status = 'pending'
            state.startProcess2025Error = undefined
        })
        builder.addCase(startProcess2025.fulfilled, (state, action) => {
            state.startProcess2025Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2025.rejected, (state, action) => {
            state.startProcess2025Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2025Error = action.error.message
            } else {
                state.startProcess2025Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2025.pending, (state) => {
            state.loadUserParamsProcess2025Status = 'pending'
            state.loadUserParamsProcess2025Error = undefined
        })
        builder.addCase(loadUserParamsProcess2025.fulfilled, (state, action) => {
            state.loadUserParamsProcess2025Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2025.rejected, (state, action) => {
            state.loadUserParamsProcess2025Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2025Error = action.error.message
            } else {
                state.loadUserParamsProcess2025Error = action.payload
            }
        })

        builder.addCase(ixHausIni_TranslatCashFlowPfad.pending, (state) => {
            state.ixHausIni_TranslatCashFlowPfadStatus = 'pending'
            state.ixHausIni_TranslatCashFlowPfadError = undefined
        })
        builder.addCase(ixHausIni_TranslatCashFlowPfad.fulfilled, (state, action) => {
            state.ixHausIni_TranslatCashFlowPfadStatus = 'idle'

            {
                state.ixHausIni_TranslatCashFlowPfad = action.payload

            }
        })
        builder.addCase(ixHausIni_TranslatCashFlowPfad.rejected, (state, action) => {
            state.ixHausIni_TranslatCashFlowPfadStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.ixHausIni_TranslatCashFlowPfadError = action.error.message
            } else {
                state.ixHausIni_TranslatCashFlowPfadError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2025,
    resetstartProcess2025Error,
    resetloadUserParamsProcess2025,
    resetloadUserParamsProcess2025Error,
    resetixHausIni_TranslatCashFlowPfad,
    resetixHausIni_TranslatCashFlowPfadError,
    removeFromProcess2025ListById,
    removeFromProcess2025ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2025Slice.actions
export default Process2025Slice.reducer
